import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import { Link } from "@components/Link/Link";
import { StyledButton } from "@components/Styled/Button";
import { StyledContainer } from "@components/Styled/Container";
import { StyledH5 } from "@components/Styled/Text";
import React, { Suspense, lazy } from "react";
import SwiperCore, { Autoplay } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw from "twin.macro";
import { withUniqueSellingPoint } from "./withUniqueSellingPoint";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);
SwiperCore.use([Autoplay]);

const GliderWrapper = tw.div`
  my-zero
`;
const Wrapper = tw(StyledContainer)`
  md:pb-midi
`;
const StyledImage = tw(Image)`
  max-w-full
`;
const ImageWrapper = tw.div`
  mr-mini min-w-peta max-w-peta
`;
const ContentWrapper = tw.div`
  flex flex-col pb-mini w-full
`;
const Title = tw(StyledH5)`
  leading-caption
`;
const Content = tw.div`
  text-caption leading-caption pr-mini
`;
const LearnMore = tw.div`
  underline mt-mini
`;
const Button = tw(StyledButton)`
  flex items-start justify-between pb-maxi pt-maxi pl-mini md:pb-mega focus-visible:!outline-offset-[-1px]
`;

const UniqueSellingPoint = withUniqueSellingPoint(
  ({ sections, autoDelay, styles }) => {
    return (
      <Container
        styles={styles}
        data-component-type="section-unique-selling-point"
      >
        <Wrapper>
          <GliderWrapper>
            <Suspense fallback={<></>}>
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                autoplay={autoDelay}
                loop={true}
                observer={true}
                observeParents={true}
                pagination={{ clickable: true }}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                  },
                }}
              >
                {sections?.map((section) => (
                  <SwiperSlide key={section.title}>
                    <Button as={Link} to={section.link.url} {...section}>
                      <ImageWrapper>
                        <StyledImage image={section.image} />
                      </ImageWrapper>
                      <ContentWrapper>
                        <Title as="span">{section.title}</Title>
                        <Content>
                          {section.content}
                          <LearnMore>{section.link.title}</LearnMore>
                        </Content>
                      </ContentWrapper>
                    </Button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Suspense>
          </GliderWrapper>
        </Wrapper>
      </Container>
    );
  },
);

export default UniqueSellingPoint;
